export const API_ROOT = 'https://data-s.freightverify.com';

// the 'path' arg should start with a slash
export default function apiUrl(path) {
  return `${API_ROOT}${path}`;
}

// link out to Covisint detail page
export function covisintMessageUrl(messageId) {
  return `https://connect.covisint.com/secured/viewDetailTransactions.do?messageID=${messageId}`;
};




// WEBPACK FOOTER //
// ./src/api-url.js